export default "__VITE_PUBLIC_ASSET__61177827__"